/** Една опция на превключвателя — стойността е тази на настройката. */
export interface SegmentOption<V extends string | boolean> {
  value: V;
  label: string;
}

/**
 * Сегментиран превключвател (pill група) вдясно на всеки ред с настройка:
 * избраният сегмент е плътен кехлибарен с бял текст, останалите — само текст.
 * Клик върху вече избрания е no-op (родителят го филтрира, за да не праща
 * излишен PUT).
 */
export function SegmentedControl<V extends string | boolean>({
  options,
  value,
  disabled,
  onChange,
}: {
  options: SegmentOption<V>[];
  value: V;
  disabled: boolean;
  onChange: (value: V) => void;
}) {
  return (
    <div
      role="group"
      className="inline-flex max-w-full flex-wrap gap-0.5 rounded-[11px] border border-shade-2 bg-fill p-1"
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={String(option.value)}
            type="button"
            disabled={disabled}
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            className={`h-8 whitespace-nowrap rounded-[8px] px-3.5 text-[13px] font-bold tracking-[-0.2px] transition-[background,color] duration-150 ${
              selected
                ? "bg-brand text-white shadow-[0_1px_2px_rgba(0,0,0,0.12)]"
                : "text-body hover:bg-shade-1 hover:text-ink"
            } ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
